// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"5520c4c56caf10a6ec68","105":"7b19466bcb7ba7db4275","108":"f03079819f8757c97349","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"000f984870f3aacbb33f","852":"642eb9335610c3f5f5e2"}[chunkId] + ".bundle.js";
};